// extracted by mini-css-extract-plugin
export var accordion = "SocketNavigation-module--accordion--3e9a6";
export var accordionPanel = "SocketNavigation-module--accordionPanel--50f7a";
export var accordionPanelLayout = "SocketNavigation-module--accordionPanelLayout--a63d1";
export var active = "SocketNavigation-module--active--ab8ce";
export var arrow = "SocketNavigation-module--arrow--8162d";
export var bright = "SocketNavigation-module--bright--cdbe9";
export var button = "SocketNavigation-module--button--fa512";
export var crossIcon = "SocketNavigation-module--cross-icon--1399b";
export var header = "SocketNavigation-module--header--e0906";
export var heading = "SocketNavigation-module--heading--ca6ba";
export var layout = "SocketNavigation-module--layout--9f232";
export var lead = "SocketNavigation-module--lead--b6a99";
export var link = "SocketNavigation-module--link--cc34c";
export var list = "SocketNavigation-module--list--d2792";
export var logo = "SocketNavigation-module--logo--103c4";
export var menuArea = "SocketNavigation-module--menuArea--df089";
export var navigation = "SocketNavigation-module--navigation--fcd35";
export var panel = "SocketNavigation-module--panel--c8f08";
export var secondaryNav = "SocketNavigation-module--secondaryNav--2b36b";
export var secondaryNavList = "SocketNavigation-module--secondaryNavList--7ae1c";
export var socket = "SocketNavigation-module--socket--17446";
export var space = "SocketNavigation-module--space--63b71";
export var stretch = "SocketNavigation-module--stretch--c64fb";
export var tag = "SocketNavigation-module--tag--1227d";
export var toggle = "SocketNavigation-module--toggle--b9792";
export var toggleIcon = "SocketNavigation-module--toggle-icon--429e6";